// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__kwvKG","small":"Timer_small__iyEKN","big":"Timer_big__+gyGI"};